// extracted by mini-css-extract-plugin
var _1 = "OY8pW";
var _2 = "_fN5s";
export { _1 as "link", _2 as "wrapper" }
